import { IIndustryInsights } from "../models/IIndustryInsights";

export default function getInsights(
  contentId: number,
  page: number,
  search: string,
  businessArea: string,
  topic: Array<string>
): Promise<IIndustryInsights> {
  const params = {
    contentId,
    page,
    businessArea,
    topic,
    search
  };

  return fetch("/api/IndustryInsightsApi/GetData", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(params)
  })
    .then((e) => e.json())
    .then((result) => result);
}
